import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ib-btn-wrap',
  templateUrl: './btn-wrap.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BtnWrapComponent {
  @Input() btnType: 'btn' | 'link' = 'btn';
  @Input() isLoading: boolean;
}
